import { useModal, withModalConditionalRender } from '@billy/design-system'
import { BanknoteXIcon } from 'lucide-react'

import { VoidBillPaymentConfirmationModal as VoidBillPaymentConfirmationModalComponent } from '@features/bills/elements/VoidBillPaymentConfirmationModal'
import { AccountingBasis } from '@modules-deprecated/app/organization/types/accountingBasis'

import { BillsTableRow } from '../../../../types/billsTableRow'
import { BillsTableActionType } from '../../enums/billsTableActionType'
import { BillsTableAction } from '../../types/billsTableAction'

const VoidBillPaymentConfirmationModal = withModalConditionalRender(VoidBillPaymentConfirmationModalComponent)

const getVoidPaymentModalId = (billId: string) => `${billId}-bills-table-void-payment`

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
export const useVoidPaymentAction = (row: BillsTableRow): BillsTableAction => {
  const modalId = getVoidPaymentModalId(row.id)
  const { open: openVoidPaymentConfirmationModal } = useModal(modalId)

  // Payments can only be voided from here for cash-based bills (same guard as the legacy bills table)
  const isCashBased = row.accountingBasis === AccountingBasis.Cash

  const getDisabledReason = (): string | null => {
    if (!isCashBased) {
      return 'Payments can only be voided from here when using cash-based accounting.'
    }

    if (!row.paymentId) {
      return 'No payment was found for this bill.'
    }

    return null
  }

  const disabledReason = getDisabledReason()

  return {
    type: BillsTableActionType.VoidPayment,
    label: 'Void payment',
    icon: BanknoteXIcon,
    onClick: openVoidPaymentConfirmationModal,
    disabled: Boolean(disabledReason),
    disabledReason,
    confirmationModal: row.paymentId ? (
      <VoidBillPaymentConfirmationModal id={modalId} paymentId={row.paymentId} />
    ) : null,
  }
}
